import { Button, Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";
import { TransferCard } from "./TransferCard";
import type { TransferFormData } from "./transfersConfig";

export function PublicTransferReviewModal({
  isOpen,
  onClose,
  transferFormData,
  onTransfer,
}: {
  isOpen: boolean;
  onClose: () => void;
  transferFormData: TransferFormData;
  onTransfer: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalHeader>Confirm Transfer</ModalHeader>

        <ModalBody>
          <TransferCard
            tokenSymbol={transferFormData.tokenSymbol}
            displayAmount={Number(transferFormData.amount)}
            senderAddress={transferFormData.l2AccountAddress.toString()}
            recipientAddress={transferFormData.recipientAddress.toString()}
          />

          <div className="w-full space-y-3">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type={transferFormData.transferMode} />
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Est. Time</div>
              <div className="font-semibold">~15 min</div>
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Gas fees</div>
              <div className="font-semibold">0.00005 ETH</div>
            </div>
          </div>

          <Button
            fullWidth
            radius="full"
            size="lg"
            color="primary"
            className="font-semibold text-large h-16"
            onPress={onTransfer}
          >
            Transfer
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
